export default __webpack_public_path__ + "static/media/Vector_desktop.c957adac.png";